import { Dispatch, SetStateAction } from 'react';

import { Table } from 'coreOld/components';
import { TableNames } from 'coreOld/constants';
import CostingHeader from 'partsOld/components/CostingHeader';
import { ICompanyPart, ICost } from 'partsOld/types';

import { TableWrapper } from './costingTabStyle';

interface IProps {
  tableColumns;
  costingList: ICost[];
  part: Partial<ICompanyPart>;
  selectedCost?: ICost;
  setSelectedCost: Dispatch<SetStateAction<ICost>>;
  onRowClick: (row) => void;
  isLoading: boolean;
  hasNextPage: boolean;
  isFetchingNextPage: boolean;
  fetchNextPage;
}

const CostingTabView = ({
  tableColumns,
  costingList,
  part,
  selectedCost,
  setSelectedCost,
  onRowClick,
  isLoading,
  hasNextPage,
  isFetchingNextPage,
  fetchNextPage,
}: IProps) => {
  return (
    <TableWrapper>
      <CostingHeader part={part} selectedCost={selectedCost} setSelectedCost={setSelectedCost} />

      <Table
        columns={tableColumns}
        data={costingList}
        name={TableNames.COSTING_LIST}
        alternating={false}
        headerLines={2}
        borderBottom={true}
        onRowClick={onRowClick}
        isLoading={isLoading}
        hasNextPage={hasNextPage}
        isFetchingNextPage={isFetchingNextPage}
        fetchNextPage={fetchNextPage}
      />
    </TableWrapper>
  );
};

export default CostingTabView;
